module.exports = __webpack_public_path__ + "static/media/aa15.5db0d08a.jpg";